module.exports = __webpack_public_path__ + "img/ey-logo.3b3b43db.svg";